<template>
  <div class="my_form">
    <el-form :model="form" ref="ruleForm" inline>
      <el-row>
        <el-col :lg="8" :md="24">
          <el-form-item label="项目名称:" prop="projectName">
            <el-select filterable clearable v-model="form.projectName" placeholder="请选择项目名称">
              <el-option
                v-for="item in projectNameOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="24">
          <el-form-item label="供货方:" prop="supplierName">
            <el-select filterable clearable v-model="form.supplierName" placeholder="请选择供货方">
              <el-option
                v-for="item in supplierNameOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="24" class="action" style="margin-bottom:20px">
            <el-button size="small" type="primary" @click="submitForm" plain>查询</el-button>
            <el-button size="small" @click="resetForm">重置</el-button>
            <el-button size="small" type="primary" @click="onExport" :loading="exportLoading">导出</el-button>
        </el-col>
      </el-row>
    </el-form>
    <STable :columns="columns" :loadData="loadData" ref="table">
      <template #sn='{ $index }'>
        {{ $index + 1 }}
      </template>
      <template #action="record">
          <a class="success" href="javascript:;" @click="updateFinalSettlementAmount(record.row)">合同实际结算金额</a>
      </template>
    </STable>
    <el-dialog title="合同实际结算金额" :visible.sync="settleDialogVisible" width="500px" :close-on-click-modal="false">
      <el-form :model="settleForm" ref="settleForm" label-width="120px">
        <el-form-item label="结算金额（元）" prop="finalSettlementAmount"
          :rules="[{ required: true, message: '请输入结算金额', trigger: 'blur' }]">
          <el-input-number style="margin-left: 0;" v-model="settleForm.finalSettlementAmount" :min="0" :precision="2" :controls="false" placeholder="请输入结算金额" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="settleDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="settleLoading" @click="handleSettleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Contract } from '@/api/contract'
import { OnlineOperation } from '@/api/onlineController.js'
import STable from '@/components/STable';
export default {
  components: {
    STable
  },
  data () {
    return {
      form: {
        projectName: '',
        supplierName: '',
        audit: ''
      },
      projectNameOptions: [],
      supplierNameOptions: [],
      columns: [
        {
          label: '序号',
          scopedSlots: 'sn',
          width: 100
        },
        {
          label: '合同名称',
          prop: 'contractName',
          ellipsis: true,
          width: 200
        },
        {
          label: '合同编号',
          prop: 'contractNo',
          ellipsis: true,
          width: 200
        },
        {
          label: '项目名称',
          prop: 'projectName',
          ellipsis: true,
          width: 350
        },
        {
          label: '供货方名称',
          prop: 'supplierName',
          width: 500,
          ellipsis: true
        },
        {
          label: '合同类别',
          prop: 'contractType',
          width: 150,
          ellipsis: true
        },
        {
          label: '含税合同金额（元）',
          prop: 'contractAmount',
          width: 180,
          ellipsis: true
        },
        {
          label: '合同实际结算金额',
          prop: 'finalSettlementAmount',
          width: 200,
          ellipsis: true
        },
        {
          label: '创建时间',
          prop: 'data42',
          width: 200,
          ellipsis: true
        },
        {
          label: '操作',
          scopedSlots: 'action',
          width: 150,
          fixed: 'right',
          ellipsis: true
        }
      ],
      loadData: (pageParam) => {
        const data = {
          ...this.form,
          ...pageParam
        }
        return Contract.getContractPageList(this, data).then(rs => rs)
      },
      exportLoading: false,
      visible: false,
      record: {},
      settleDialogVisible: false,
      settleLoading: false,
      settleForm: {
        finalSettlementAmount: 0
      },
      settleRecord: {}
    }
  },
  created () {
    this.loadProjectOptions()
    this.loadSupplierOptions()
  },
  methods: {
    loadProjectOptions () {
      OnlineOperation.listDict(this, {
        dictId: '1637650160030846976'
      }).then(res => {
        this.projectNameOptions = res.data.map(item => ({
          label: item.name,
          value: item.name
        }))
      })
    },
    loadSupplierOptions (projectName) {
      Contract.getSupplierListAll(this, {
        oaFormContractDto: {
          // projectName: projectName || ''
        }
      }).then(res => {
        const dataList = res.data || []
        this.supplierNameOptions = dataList.map(item => ({
          label: item,
          value: item
        }))
      })
    },
    handleDelete (record) {
      this.$confirm('是否删除当前数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        CityProject.deleteCityProject(this, {datasourceId: '1631120104961871872', dataId: record.id}).then(() => {
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.submitForm(false)
        })
      })
    },
    handleOpenDetail (record) {
      this.record = record
      this.visible = true
    },
    updateFinalSettlementAmount (record) {
      this.settleRecord = record
      this.settleForm.finalSettlementAmount = record.finalSettlementAmount || 0
      this.settleDialogVisible = true
    },
    handleSettleSubmit () {
      this.$refs.settleForm.validate(valid => {
        if (!valid) return
        this.settleLoading = true
        Contract.updateFinalSettlementAmount(this, {
          id: this.settleRecord.id,
          finalSettlementAmount: this.settleForm.finalSettlementAmount
        }).then(res => {
          this.settleLoading = false
          if (res.success) {
            this.$message.success('更新成功')
            this.settleDialogVisible = false
            this.submitForm(false)
          } else {
            this.$message.error(res.data.msg || '更新失败')
          }
        }).catch(() => {
          this.settleLoading = false
        })
      })
    },
    onExport () {
      this.exportLoading = true
      this.download('/admin/upms/oaContract/exportPageList', { ...this.form }, '合同列表.xls')
        .then(() => {
          this.$message.success('导出成功！')
        }).catch(e => {
          this.$message.error(e)
        }).finally(() => {
          this.exportLoading = false
        })
    },
    submitForm (flag = true) {
      if (this.$refs.table) this.$refs.table.refresh(flag)
    },
    resetForm () {
      this.form = {}
      this.$refs.table.refresh(true)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/element-variables.scss';
  .title {
    border: 1px solid #EDEDED;
    border-left-width: 5px;
    border-left-color: $--color-primary;
    margin-bottom: 20px;
  }

  .title p {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    margin: 0px;
    padding-left: 20px;
  }

  .title p span {
    font-size: 20px;
    color: $--color-primary;
  }

  .item-list {
    margin: 0px;
  }
  .item-list li {
    margin: 10px 0px;
  }

  .item {
    height: 48px;
    display: flex;
    align-items: center;
  }
  ::v-deep .el-form-item__content{
    margin-left: 0 !important;
  }
</style>
